export const FORM_REGULAR = 'regular';
export const FORM_FREE = 'free';
export const FORM_GIFT = 'giftActivate';
